import React, { useState } from "react";

import { InputText } from "primereact/inputtext";
import { Fade } from "react-reveal";


export default function UserSearch(props) {
    const users = props.users;
    const [userInput, setUserInput] = useState("");
    const [searchResults, setSearchResults] = useState([]);

    const containsPerson = (person) => {
        for (var i = 0; i < searchResults.length; i++) {
            if (searchResults[i] === person) {
                return true;
            }
        }

        return false;
    }

    const onSearchInput = (event) => {
        // Local Variable to Protect Against Async
        const input = event.target.value.toLowerCase();
        var localResults = searchResults;
        // Update Info
        setUserInput(event.target.value);

        if (input.length > 0) {
            users.forEach(user => {
                const fullName = user.firstName.toLowerCase() + " " + user.lastName.toLowerCase();
                if (fullName.includes(input) ||
                user.email.toLowerCase().includes(input)) {
                    if (!containsPerson(user)) {
                        localResults.push(user);
                    }
                } else {
                    localResults = localResults.filter(e => e !== user);
                }
            });
            setSearchResults(localResults);
        } else {
            setSearchResults([]);
        }
    }

    const renderResults = () => {
        if (searchResults.length > 0) {
            return (
                <>
                    {searchResults.map((item, index) => {
                        return (
                            <Fade>
                                {props.renderUser(item)}
                            </Fade>
                        )

                    })
                    }
                </>
            )
        }
    }

    return (
        <>
            <ul className="applications-list">
                <h1 className="header">Search for User</h1>
                <div className="search-input">
                    <InputText value={userInput} onInput={onSearchInput}></InputText>
                </div>

                <div>
                    {renderResults()}
                </div>

            </ul>
        </>
    )
}